module.exports = __webpack_public_path__ + "img/21-40.f8b2be78.svg";